import { Component, OnInit, OnDestroy } from '@angular/core';
import { MyAccountService } from '../../services/myAccount.service';
// tslint:disable-next-line:import-blacklist
import { Subject, Subscription } from 'rxjs';
import { B2BV2APIClientCredentials } from '../../models/b2brestApitokens';
import { Router } from '@angular/router';
import { AuthService } from '../../services/auth.service';
import { CurrentUserModel } from '../../models/account-ledger.model';
import { ApiResponse } from '../../models/api-response.model';
import { CommonService } from '../../services';
import { AccountContact } from '../../models/Profile-view.model';
import { takeUntil } from 'rxjs/operators';
import { DatePipe } from '@angular/common';

declare var $: any;

@Component({
  selector: 'app-apicredentialsV2',
  templateUrl: './apicredentialsV2.component.html',
  styleUrls: ['./apicredentialsV2.component.css']
})
export class ApicredentialsV2Component implements OnInit, OnDestroy {

  title = 'API Credentials V2';
  liveOrTest = 'test'; // TODO: change to 'live' once switch to the live domain
  loadContent = false;
  hasAdminAccess = false;
  modalDetails = {
    title: 'API Credentials Confirmation',
    content: 'The sandbox credentials has been generated successfully.'
  };
  showApiBox = false;
  accountId: string;
  companyCode: string;
  userList = [];
  currentUser: string;
  currentUserEmail: string;
  credentialsDisplayName: string;

  prodCredentialsLoading: boolean = false;
  sandboxCredentialsLoading: boolean = false;

  prodCredentials: B2BV2APIClientCredentials[] = [];
  sandboxCredentials: B2BV2APIClientCredentials[] = [];

  isTestMode = false;

  ngUnsubscribe: Subject<void> = new Subject<void>();

  constructor(
    private myAccountService: MyAccountService,
    private router: Router,
    private authService: AuthService,
    private commonService: CommonService,
  ) { }

  ngOnInit() {

    this.authService.getLoginInfo().pipe(takeUntil(this.ngUnsubscribe))
     .subscribe((res: CurrentUserModel) => {
      if (res && res.hasAdminAccess) {
        this.accountId = res.accountId;
        this.companyCode = res.companyCode;
        this.currentUser = res.loginId;
        this.currentUserEmail = res.email;

        this.isTestMode = this.companyCode.toUpperCase().startsWith('T');

        this.getAccountUserList();

        this.myAccountService.GetAPIIntegrationStatus().pipe(takeUntil(this.ngUnsubscribe)).subscribe((response: ApiResponse) => {
          if (response && response.status) {
            this.showApiBox = response.status;
          }
          if (res.isStaffAccount || this.showApiBox) {
            this.hasAdminAccess = res.hasAdminAccess;
            this.prodCredentialsLoading = true;            
            this.myAccountService.GetB2BAPIV2Credentials(this.accountId, false).pipe(takeUntil(this.ngUnsubscribe)).subscribe((credentialsList: B2BV2APIClientCredentials[]) => {
              if (credentialsList != null) {
                this.prodCredentials = credentialsList;
                this.prodCredentialsLoading = false;
              }
            });
            if (!this.isTestMode) {
              this.sandboxCredentialsLoading = true;
              this.myAccountService.GetB2BAPIV2Credentials(this.accountId, true).pipe(takeUntil(this.ngUnsubscribe)).subscribe((credentialsList: B2BV2APIClientCredentials[]) => {
                if (credentialsList != null) {
                  this.sandboxCredentials = credentialsList;
                  this.sandboxCredentialsLoading = false;
                }
              });
            }
          } else {
            this.commonService.implementToast('Not allowed to API integration', 'Error');
            this.router.navigateByUrl('/myAccount');
          }
        },
        (error: any) => {
          console.error(error);
        });       

      }
    },
      (error: any) => {
        console.error(error);
      });
  }

  close() {
    this.router.navigateByUrl('/myAccount');
  }

  generateCredentials(environment: string) {

    if (!this.currentUserEmail) {
      this.commonService.implementToast('Please select email from contact list or enter your own email address', 'Info');
      return;
    }

    if (!this.emailIsValid(this.currentUserEmail)) {
      this.commonService.implementToast('Invalid email address', 'Info');
      return;
    }

    if (environment == 'prod') {
      this.myAccountService.GenerateB2BAPIV2Credentials(this.credentialsDisplayName, false).pipe(takeUntil(this.ngUnsubscribe)).subscribe((res: B2BV2APIClientCredentials) => {
        this.prodCredentials.push(res);
      });
    }

    if (environment == 'sandbox') {
      this.myAccountService.GenerateB2BAPIV2Credentials(this.credentialsDisplayName, true).pipe(takeUntil(this.ngUnsubscribe)).subscribe((res: B2BV2APIClientCredentials) => {
        this.sandboxCredentials.push(res);
      });
    }
  }

  getAccountUserList() {
    this.myAccountService.GetAccountUserList(this.accountId).pipe(takeUntil(this.ngUnsubscribe))
    .subscribe((result: any) => {

      if (result) {
        this.userList = result.filter(item => item.out_login_id !== '' && item.out_email !== '');
      }

    },
    (error: any) => {
      console.error(error);
    });
  }

  onLoading(currentLoadingStatus: boolean) {
    this.loadContent = !currentLoadingStatus;
  }

  emailIsValid (email: string) {
    return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email);
  }

  ngOnDestroy() {
    this.ngUnsubscribe.next();
    this.ngUnsubscribe.complete();
  }

  deleteCredentials(env: string, dbIndex: string, index: number) {
  
      switch(env) {
        case 'sandbox':
          this.myAccountService.DeleteB2BAPIV2Credentials(dbIndex, true).subscribe(success => {
            if (success == true) {
              this.sandboxCredentials.splice(index, 1);
            } else {

            }
          });          
          break;
        case 'prod':
          this.myAccountService.DeleteB2BAPIV2Credentials(dbIndex, false).subscribe(success => {
            if (success == true) {
              this.prodCredentials.splice(index, 1);
            } else {

            }
          });
          break;
      }
  
  }

  copyText(textToCopy: string) {
    if (textToCopy) { 
      this.copyToClipboard(textToCopy);
      this.commonService.implementToast('Copied to clipboard successfully', 'Success');
    }
  }

  copyToClipboard(item: any): void {
    const listener = (e: ClipboardEvent) => {
        e.clipboardData.setData('text/plain', (item));
        e.preventDefault();
    };

    document.addEventListener('copy', listener);
    document.execCommand('copy');
    document.removeEventListener('copy', listener);
  }

}
